import { blue, red, textMuted } from '@/theme/colors'
import styled from 'styled-components'

/** Heading that separates the payups list from the expenses list above it. */
export const SectionHeading = styled.h2`
	margin: 2.5rem 0 1rem;
	font-size: 1.15rem;
	font-weight: 700;
	color: ${blue};
`

/**
 * A non-clickable table row for the payups list (payups have no detail page).
 * Soft-deleted payups get a faint red tint, matching the clickable list rows.
 */
export const StaticRow = styled.tr<{ $deleted?: boolean }>`
	background-color: ${({ $deleted }) => ($deleted ? `${red}10` : 'transparent')};

	&:last-child td {
		border-bottom: none;
	}
`

export const EmptyState = styled.div`
	color: ${textMuted};
	font-size: 1rem;
`

export const ErrorState = styled.div`
	color: ${textMuted};
	font-size: 1rem;
`
